var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"boutonRond",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.click.apply(null, arguments)}}},[_c('img',{attrs:{"src":'/assets/icons_' + _vm.$store.state.iconTheme + '/friends.png'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }